import React,{useState,useEffect} from 'react';
import {Row,Col,Card,Spin,Divider,Layout,Popconfirm,Button} from "antd";
import {  CloseCircleOutlined } from "@ant-design/icons";
import { useSelector,useDispatch } from "react-redux";
import AdminSideBar from './AdminSideBar';
import { getUploadedDocuments } from '../../features/UploadedDocumentsSlice';

const { Content} = Layout;

function ApprovedClients() {
    const [Loading, setLoading] = useState(false);
    const { user: currentUser } = useSelector((state) => state.auth);
    const kycs = useSelector((state) => state.uploadedDocuments);

    const id = currentUser.Id;
    const clientAPIkey = currentUser.ClientApikey;
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getUploadedDocuments())
      }, [dispatch]);

      function confirmReviewed(){
        console.log('document confirmed');
      }
  return (
    <Content style={{marginTop:'5%'}}>  
    <Layout hasSider >
     <AdminSideBar props='3'/>
    <Layout className="site-layout">
      <Content style={{ margin: '10px 0px 0', overflow: 'initial' }}> 
    <Row gutter={[24, 0]}>
      <Col xs={24} sm={24} md={12} lg={12} xl={24} className="mb-24">
        <Card
          bordered={false}
          className="criclebox cardbody h-full">
        <div className="ant-list-box table-responsive">
           <Divider/>
          <table className="width-100">
            <thead>
              <tr>
                <th>Client Name</th>
                <th>Document</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              { kycs.status==='loading'||Loading?<Spin size='large'  tip="Loading..." style={{margin:'30% 100%'}}/>:
              kycs.list?.filter(function (file) {
                return file.Verified === 1;
                 })?.map((information) => (
                <tr key={information.Filename}>
                  <td>
                    <h6>
                      {information.Filename}
                    </h6>
                  </td>
                  <td>
                    <h6>{information.Description}</h6></td>
                    <td>
                      <Popconfirm
                            title=" Remove this from approved?"
                            onConfirm={()=>confirmReviewed(id,information.Filename,clientAPIkey)}
                            okText="Yes"
                            cancelText="No">
                            <Button icon={<CloseCircleOutlined />} style={{borderRadius:5}} type='primary' danger>Remove</Button> 
                      </Popconfirm>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </Card>
      </Col>
    </Row> 
      </Content>
    </Layout>
  </Layout>
  </Content>
  )
}

export default ApprovedClients